var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('div',{staticClass:"card_wrapper",style:({
      padding: _vm.ispadding == true ? '0 20px' : '0',
    })},[_c('div',{staticClass:"card_item_pic"},[_c('img',{staticClass:"card_item_pic_img",attrs:{"src":_vm.imgSrc(),"alt":""}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }